
import React, {useEffect} from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { FaLocationDot, FaDownload } from "react-icons/fa6";
import { MdOutlineFileDownload } from "react-icons/md";
import { Link } from "react-router-dom";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";


const AboutContent = ({contentData}) => {
    const controls = useAnimation();
    const [ref, inView] = useInView({
      triggerOnce: true,
    });
  
    const scaleVariants = {
      hidden: { scale: 0 },
      visible: {
        scale: 1.05,
        transition: {
          duration: 0.7,
          delay : 0.1
        },
      },
    };
  
    useEffect(() => {
      if (inView) {
        controls.start("visible");
      }
    }, [controls, inView]);
  
    return (
      <motion.div
        className="about-content-main-wrapper"
        ref={ref}
        initial="hidden"
        animate={controls}
        variants={scaleVariants}
      >
        <div className="about-header-title-section d-flex justify-content-between">
                      <h3>I'm Khan Maheeb</h3>

                      <div className="about-header-social-section">
                        <h5>
                          I'm on
                          {contentData.social_links.map((social , ind) => {
                            return (
                              <span className={`${ind == 0} ? add-extra-margin : social-icon-box`}>
                                <Link to={social?.link} target="__blank">
                                  {ind == 0 ? <FaXTwitter /> : ind == 1 ? <FaLinkedin /> : <FaInstagram />}
                                </Link>
                              </span>
                            )
                          })}
                        </h5>
                      </div>
                    </div>
                    <hr className="custom-hr"></hr>
                    <div className="about-section-data-content">
                      <div className="about-section-text-data">
                        {contentData?.aboutinfo?.length > 0  && contentData?.aboutinfo?.map((content) => (
                          <p>{content.info}</p>
                        ))}
                      </div>
                    </div>
                    <hr className="custom-hr"></hr>
                    <div className="about-section-footer-box">
                      <div className="about-section-footer-social-details flex-lg-row flex-column d-flex justify-content-between">
                        <div className="footer-social-box d-flex flex-lg-row flex-column ">
                          <p>
                            <a>
                              
                              <FaLocationDot /> Lives In {contentData?.address}
                            </a>
                          </p>
                          <p className="mx-lg-4">
                            <a>
                              {contentData?.contact?.mail}
                            </a>
                          </p>
                        </div>

                        <div className="download-resume-btn-box">
                          <button>
                            <a>
                            <span className="download-icon"><MdOutlineFileDownload/></span>
                              Download Resume
                            </a>
                          </button>
                        </div>
                      </div>
                    </div>
      </motion.div>
    );
  };
  
export default AboutContent;
  

